import React, { Component }  from 'react';
import PropTypes      from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { countryCityActions } from '../../redux/actions/countryCityActions';
import { isNull } from 'util';
import loader from '../../style/cityloader/cityloader.scss';



const propTypes = {
    countries: PropTypes.array.isRequired
};
let cityItems=[], isLoading='false'; let countrybg="", statebg="",citybg="";
class CountryStateCity extends Component {
    static propTypes= {
        //countrydata: PropTypes.array,
        onSelectedCountry: PropTypes.func,
        onSelectedState: PropTypes.func,
        onSelectedCity: PropTypes.func,
        stateitem: PropTypes.string
    };
    constructor (props) {
        super(props);
        this.state ={
            countryData:[],
            statesName:[],
            citiesData:[],
            country:'',
            city:'',
            cityID:'',
            state:'',
            stateName:'',
            countryName:''
        }
        this.handlesOnCountryChanged=this.handlesOnCountryChanged.bind(this);
        this.handlesOnStateChanged=this.handlesOnStateChanged.bind(this);
        this.handlesOnCityChanged=this.handlesOnCityChanged.bind(this);
    }
    handlesOnCountryChanged(e){
        isLoading='true';
        this.setState({[e.target.name]:e.target.value});
        countrybg="";
        const selectedCountry = this.state.countryData.find(k => k.country == e.target.value);
        //console.log('handle change country', selectedCountry.countryName)
        this.setState({countryName:selectedCountry.countryName});

        this.props.dispatch(countryCityActions.getStateData(e.target.value));
        //this.props.onSelectedCountry(e.target.value);
    } 
    handlesOnStateChanged(e){
        isLoading='true';
        statebg="";
        this.setState({[e.target.name]:e.target.value});
        const selectedState = this.state.statesName.find(k => k.stateAbbr == e.target.value);
        //console.log("state select",selectedState.state);
        this.setState({stateName:selectedState.state});
        try{
            this.props.dispatch(countryCityActions.get_city_ByState(e.target.value));
        }
        catch (error) {
            alert('error:', error);
        }
       
        //this.setState({citiesData:this.props.cityDetailsByState});
        
        //this.props.onSelectedState(e.target.value);
    }
    
    handlesOnCityChanged(e){
        citybg="";
        this.setState({city:e.target.value});

        const selectedCity = this.state.citiesData.find(k => k.title == e.target.value);
       
        this.setState({cityID:selectedCity.cityID});
       
    }
    componentWillMount(){
        const { dispatch } = this.props;
        dispatch(countryCityActions.get_country_data());

       

        if(this.props.countries){
            this.setState({countryData:this.props.countries});
            this.setState({country:this.props.country, countryName:this.props.countryName});
            //this.props.onSelectedCountry(this.props.country,this.props.countryName );
        
            if(this.props.country){
                this.props.dispatch(countryCityActions.getStateData(this.props.country));
                this.setState({statesName:this.props.states});
                console.log('city mount',this.props.states);
                this.setState({state:this.props.stateAbbr, stateName:this.props.state})    
            }
        }
        
        
        if(this.props.state){
          
            this.props.dispatch(countryCityActions.get_city_ByState(this.props.stateAbbr));
            this.setState({citiesData:this.props.cityDetailsByState });
            //this.state.citiesData=[{title:this.props.city,cityID:this.props.cityId}];
            this.setState({city:this.props.city, cityID:this.props.cityID});
        }
        
        // const rehydrate = JSON.parse(localStorage.getItem('cityCountrySateSavedState'))
        // this.setState(rehydrate)
    }

    componentWillReceiveProps(nextProps){
        if(this.props.countryerror !== nextProps.countryerror){
            //console.log('country prop',nextProps.countryerror );
            nextProps.countryerror== "true"?countrybg="red": countrybg="";
        }
        if(this.props.stateerror !== nextProps.stateerror){
           // console.log('state prop',nextProps.stateerror );
            nextProps.stateerror=="true"? statebg="red": statebg="";
        }
        if(this.props.cityerror !== nextProps.cityerror){
           // console.log('city prop',nextProps.cityerror );
            nextProps.cityerror=="true"? citybg="red": citybg="";
        }
        if(this.props.country !== nextProps.country){
         // console.log('country prop',nextProps.country )
            this.props.dispatch(countryCityActions.getStateData(nextProps.country));
            this.setState({state:nextProps.stateAbbr, stateName:nextProps.state,country:nextProps.country, cityID:nextProps.cityID}) 
        }

        if (this.props.countries !== nextProps.countries){
            if(this.props.country){
                this.props.dispatch(countryCityActions.getStateData(this.props.country));
                this.setState({state:this.props.stateAbbr, stateName:this.props.state,country:this.props.country}) 
            }
            this.setState({countryData:nextProps.countries});
       // console.log('country comp', nextProps.countries)
        }

        if (this.props.states !== nextProps.states) {
            if(this.props.stateAbbr){
                this.props.dispatch(countryCityActions.get_city_ByState(this.props.stateAbbr));
                this.setState({city:this.props.city,cityID: this.props.cityID, citiesData:this.props.cityDetailsByState}) 
            } 
          this.setState({statesName:nextProps.states})
            isLoading='false';
          // console.log('state comp', nextProps.states)
        }
       
       if(this.props.cityDetailsByState !== nextProps.cityDetailsByState){
            this.setState({citiesData:nextProps.cityDetailsByState})
            isLoading='false';
        }

        if(this.props.error !== nextProps.error){
            if(nextProps.error){
                isLoading='false';
            }
        }
    }

    componentWillUpdate(nextProps, nextState, prevState, prevProps) {

        if (
          this.state.country !==
          nextState.country
        ) {
           // console.log('Willupdate')
            nextProps.onSelectedCountry(nextState.country, nextState.countryName);
            
          //nextProps.onChange(nextState.someStatefulValue);
        }
        
        if (
            this.state.state !==
            nextState.state
          ) {
              nextProps.onSelectedState(nextState.state, nextState.stateName);
            //nextProps.onChange(nextState.someStatefulValue);
        }
        if (
            this.state.city !==
            nextState.city
          ) {

            //console.log('Willupdate city')
            if(nextState.cityID !== undefined){
              nextProps.onSelectedCity(nextState.city, nextState.cityID);
            }
            //nextProps.onChange(nextState.someStatefulValue);
        }
          
      }

    //   componentDidUpdate(prevProps, prevState) {
    //     if (
    //         this.props.country !==
    //         prevState.country
    //       ) {
    //           console.log('didupdate')
           
    //         //this.state.countryData=[{country:this.props.country,countryName:this.props.countryName}];
    //         //this.setState({country:this.props.country, countryName:this.props.countryName});
    //         prevProps.onSelectedCountry(prevState.country,prevState.countryName );
    //         //nextProps.onChange(nextState.someStatefulValue);
    //       }
    //       if (
    //           this.props.state !==
    //           prevState.state
    //         ) {
    //             //this.state.statesName=[{state:this.props.state,stateAbbr:this.props.stateAbbr}];
    //             //this.setState({state:this.props.stateAbbr, stateName:this.props.state})
    //             prevProps.onSelectedState(prevState.state,prevState.stateName );
    //             //this.props.dispatch(countryCityActions.getStateData(this.props.country));
    //           //nextProps.onChange(nextState.someStatefulValue);
    //       }
    //       if (
    //           this.props.city !==
    //           prevState.city
    //         ) {
    //             //console.log('Didupdate city')
                
    //             //this.state.citiesData=[{title:this.props.city,cityID:this.props.cityId}];
    //             //this.setState({city:this.props.city})
    //            // this.setState({cityID:this.props.cityId})
    //             prevProps.onSelectedCity(prevState.city, prevState.cityID);
    //             //this.props.dispatch(countryCityActions.get_city_ByState(this.props.stateAbbr));
    //           //nextProps.onChange(nextState.someStatefulValue);
    //       }
    //   }

    render() {
       
           
    

        // console.log('testing', this.state, this.props);
       
        //let countrydata= (this.props.countries) ? this.props.countries : [];
        let countrydata= (this.state.countryData) ? this.state.countryData : [];
        let countryItems;
        
        if(countrydata){
            countryItems= countrydata.map((countryObject, index) =>
            <option key={index} value={countryObject.country}>{countryObject.countryName}</option>
            );
        }
        

        //console.log('countryItems', countryItems);
        let statedata= (this.state.statesName) ? this.state.statesName : [];
        let stateItems;
        
        if (statedata){
            stateItems = statedata.map((stateObject, index) =>
                <option key={index} value={stateObject.stateAbbr}>{stateObject.state}</option>
            );
        }
        
        let citiesdata= (this.state.citiesData) ? this.state.citiesData : [];
        if (citiesdata){
        //console.log('cityitems data',this.state.citiesData);
            cityItems = citiesdata.map((cityObject, index) =>
                <option key={index} value={cityObject.title}>{cityObject.title}</option>
            );
        }
        return (
           
           <div className="city">  
                {(isLoading =='true') ?
                
                <div className="loader">
                <p className="loading-message">
                <i>
                    Loading...
                </i>
                </p>
                <div className="spinner">
                    <div className="dot1"></div>
                    <div className="dot2"></div>
                </div>
                </div> : ''
                }
                <div className="form-group">
                <label htmlFor="country">
                Country
                </label>
                <select name="country" className="form-control" style={{borderColor:countrybg}} value={this.state.country}  onChange={this.handlesOnCountryChanged}>
                <option>Select a country</option>
                {countryItems}
                </select>
                </div>

                <div className="form-group">
                <label htmlFor="state">
                State
                </label>
                <select name="state"  className="form-control"  style={{borderColor:statebg}}  value={this.state.state}  onChange={this.handlesOnStateChanged}>
                <option>Select a state</option>
                {stateItems}
               
                </select>
                </div>

                <div className="form-group">
                <label htmlFor="title">
                City
                </label>
                <select name="title" className="form-control" value={this.state.city}  style={{borderColor:citybg}}  onChange={this.handlesOnCityChanged}>
                <option>Select a city</option>
                {cityItems}
                
                </select>
                </div>
                
            </div>
        );
    }        

}

const mapStateToProps = (state,ownProps) => {
    //console.log('index ccs',state.countries);
    return {
    countries :state.countryCityReducers.countries,
    states: state.countryCityReducers.states,
    cityDetailsByState: state.countryCityReducers.cityDetailsByState,
    error: state.countryCityReducers.error
    };
  };

  export default connect(mapStateToProps)(CountryStateCity);



// WEBPACK FOOTER //
// ./src/app/components/countryStateCity/CountryStateCity.js